import { createFileRoute } from "@tanstack/react-router";

/** Both params are optional, so plain `<Link to="/login" />` stays valid. */
export interface AuthSearch {
  /** Where to land once signed in (legacy `?next=`). Sanitized before use. */
  next?: string;
  /** Failure code bounced back by an OAuth callback. */
  error?: string;
}

export function parseAuthSearch(search: Record<string, unknown>): AuthSearch {
  return {
    ...(typeof search.next === "string" ? { next: search.next } : {}),
    ...(typeof search.error === "string" ? { error: search.error } : {}),
  };
}

/**
 * `/login` — rendered by `__root.tsx`'s auth branch (as `/auth` was before it),
 * so the component here is a placeholder. The route exists to register the path
 * and to type its search params.
 */
export const Route = createFileRoute("/login")({
  validateSearch: parseAuthSearch,
  component: () => null,
});
